import { DataBean } from "../DataBean";

export class ImportDeclaration extends DataBean {


    public async getImportDeclarationCatalogPorPropiedades(properties:any,maxRows:any): Promise<any> {
        return this.getCustomService("ProcessContractERP", "java.util.List_getImportDeclarationCatalogPorPropiedades_java.util.Map_Number", [properties,maxRows]);
    }


 
}